import { motion } from "framer-motion";
import { PROCESS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const ProcessSection = () => (
  <section data-testid="process-section" className="relative border-t border-white/10 py-24 md:py-32">
    <div className="mx-auto max-w-[1440px] px-6 md:px-12">
      <Reveal className="mb-16 max-w-3xl">
        <div className="mb-4 flex items-center gap-3">
          <span className="h-px w-10 bg-brand-cyan" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-cyan">The Process</span>
        </div>
        <h2 className="font-display text-4xl font-extrabold leading-[0.98] tracking-tight md:text-5xl">
          Four disciplined steps. No shortcuts.
        </h2>
      </Reveal>

      <div className="border-t border-white/10">
        {PROCESS.map((p, i) => (
          <motion.div key={p.n} data-testid={`process-${p.n}`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            className="group grid grid-cols-1 items-baseline gap-4 border-b border-white/10 py-10 transition-colors hover:bg-panel/40 md:grid-cols-[120px_1fr_2fr] md:py-14 md:px-4">
            <span className="font-mono text-sm text-brand-cyan">{p.n}</span>
            <h3 className="font-display text-3xl font-extrabold tracking-tight transition-transform duration-500 group-hover:translate-x-2 md:text-5xl">{p.title}</h3>
            <p className="max-w-xl font-body text-base leading-relaxed text-slatex-300">{p.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default ProcessSection;
